module.exports = __webpack_public_path__ + "img/daftpunktocat-thomas.a171908b.gif";